import type { Ref } from 'vue';
import type { EChartsType } from 'echarts/core';

type TVueEChartsComponent = {
  getEchartsInstance?: () => EChartsType | undefined;
  chart?: EChartsType | Ref<EChartsType | undefined>;
};

export const resolveEChartsInstance = (component: TVueEChartsComponent | null | undefined): EChartsType | undefined => {
  if (!component) return undefined;

  const instanceFromMethod = component.getEchartsInstance?.();
  if (instanceFromMethod) return instanceFromMethod;

  const chart = component.chart;
  if (!chart) return undefined;

  if (typeof chart === 'object' && chart !== null && 'value' in chart) {
    return chart.value;
  }

  return chart;
};
